module.exports = __webpack_public_path__ + "img/bookshelf_left.8cb629b7.png";